
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 158 143.4"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M79 121.2L115.3 0H158l-50.4 143.4h-57L0 0h42.6L79 121.2z","opacity":".75","fill":"#7a1713"}})])
          )
        }
      }
    